export enum SemiLoginType {
    MAIL_ADDRESS = 'email',
    FACEBOOK = 'facebook',
    GOOGLE = 'google',
    APPLE = 'apple',
}
